import { EgretLoadable } from "egret";
import { Redirect } from "react-router-dom";
import AccountantRouter from "./Accountant/AccountantRouter";
import ConstantList from "./appConfig";
import dashBoardRoute from "./DashBoard/DashBoardRoute";
import ManagementRouter from "./Management/ManagementRouter";
import PatientManagementRouter from "./PatientManagement/PatientManagementRouter";
import PublicRoute from "./Public/PublicRouter";
import ReportRouter from "./Report/ReportRouter";
import StaffRouter from "./Staff/StaffRouter";
import TreatmentManagementRouter from "./TreatmentManagement/TreatmentManagementRouter";
import sessionRoutes from "./views/sessions/SessionRoutes";

const redirectRoute = [
  {
    path: ConstantList.ROOT_PATH,
    exact: true,
    component: () => <Redirect to={ConstantList.HOME_PAGE} />, //Luôn trỏ về HomePage được khai báo trong appConfig
  },
];

const errorRoute = [
  {
    component: () => <Redirect to={"setting/profile"} />,
  },
];

const modulesRoute = {
  path: "module",
  exact: true,
  component: EgretLoadable({
    loader: () => import("./common/Layout/PageModule"),
  }),
};

const routes = [
  ManagementRouter,
  StaffRouter,
  ReportRouter,
  modulesRoute,
  PublicRoute,
  dashBoardRoute,
  PatientManagementRouter,
  TreatmentManagementRouter,
  AccountantRouter,
  ...redirectRoute,
  ...sessionRoutes,
  // ...errorRoute,
];

export default routes;
